import React from "react";
import GridLine from "./GridLine";

function About() {
  return <section id="approach" className="subGrid thirdRow">
    <GridLine />
  </section>;
}

export default About;